import { inject, Injectable } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';
import { TaskCancelReasonResponse } from '../models/task.model';
import { DrawerRegistryService } from '../../../shared/services/drawer-registry.service';

export interface TaskCancelReasonDrawerOptions { cancelReasonId?: number; }

@Injectable({ providedIn: 'root' })
export class TaskCancelReasonDrawerService {
  private readonly registry = inject(DrawerRegistryService);
  private readonly state$ = new BehaviorSubject<{ isOpen: boolean; options: TaskCancelReasonDrawerOptions }>({
    isOpen: false, options: {}
  });
  private readonly saved$$ = new Subject<TaskCancelReasonResponse>();

  readonly state = this.state$.asObservable();
  readonly saved$ = this.saved$$.asObservable();

  open(options: TaskCancelReasonDrawerOptions = {}): void {
    if (!this.state$.value.isOpen) this.registry.opened();
    this.state$.next({ isOpen: true, options });
  }

  close(): void {
    if (this.state$.value.isOpen) this.registry.closed();
    this.state$.next({ isOpen: false, options: {} });
  }
  notifySaved(item: TaskCancelReasonResponse): void { this.saved$$.next(item); }
}
